export default "__VITE_ASSET__b9c9591d__"